
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["enlarge_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M853.333 0H170.667C75.093 0 0 75.093 0 170.667v682.666C0 948.907 75.093 1024 170.667 1024h682.666C948.907 1024 1024 948.907 1024 853.333V170.667C1024 75.093 948.907 0 853.333 0zm102.4 853.333c0 54.614-47.786 102.4-102.4 102.4H170.667c-54.614 0-102.4-47.786-102.4-102.4V170.667c0-54.614 47.786-102.4 102.4-102.4h682.666c54.614 0 102.4 47.786 102.4 102.4v682.666z","fill":"#777"}}),_c('path',{attrs:{"d":"M402.773 573.44L204.8 771.413v-122.88c0-20.48-13.653-34.133-34.133-34.133s-34.134 13.653-34.134 34.133v204.8c0 20.48 13.654 34.134 34.134 34.134h204.8c20.48 0 34.133-13.654 34.133-34.134S395.947 819.2 375.467 819.2h-122.88L450.56 621.227c13.653-13.654 13.653-34.134 0-47.787-13.653-13.653-34.133-13.653-47.787 0zm450.56-436.907h-204.8c-20.48 0-34.133 13.654-34.133 34.134s13.653 34.133 34.133 34.133h122.88L573.44 402.773c-13.653 13.654-13.653 34.134 0 47.787 13.653 13.653 34.133 13.653 47.787 0L819.2 252.587v122.88c0 20.48 13.653 34.133 34.133 34.133s34.134-13.653 34.134-34.133v-204.8c0-20.48-13.654-34.134-34.134-34.134z","fill":"#777"}})])
          )
        }
      }
    